import React from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';

import MailSvg from 'eventbrite_design_system/iconography/icons/Mail';

import NotificationScreen from '../../components/NotificationScreen';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/RESET_PASSWORD_STATUS_PATH
 */
export default class ResetPasswordStatusPage extends React.PureComponent {
    static propTypes = {
        email: PropTypes.string,
    };

    render() {
        const { email } = this.props;
        const iconType = <MailSvg />;
        const headerText = gettext('Check your email');
        let subtitleText = gettext(
            'We sent you an email with instructions to reset your password.',
        );

        //Need to conditionally check if the email is present and update copy accordingly
        //in case the user refreshes the notification page and we lose the email from state.
        if (email) {
            subtitleText = gettext(
                'We sent an email to %(email)s with instructions to reset your password.',
                { email },
            );
        }

        return (
            <div className="eds-l-mar-vert-14">
                <NotificationScreen
                    iconType={iconType}
                    headerText={headerText}
                    subtitleText={subtitleText}
                />
            </div>
        );
    }
}
